export interface Geography {
  id?: number | null
  state: string
  country: string
  worldRegion: string
}

export interface GeoTreeNode {
  value: Geography
  children?: GeoTreeNode[]
}

export enum WorldRegion {
  Any = 'any',
  NorthAmerica = 'north america',
  SouthAmerica = 'south america',
  CentralAmerica = 'central america',
  Caribbean = 'caribbean',
  Asia = 'asia',
  Africa = 'africa',
  Europe = 'europe',
  Oceania = 'oceania',
  MiddleEast = 'middle east'
}
// 'Armenia, Azerbaijan, Bahrain, Egypt, Georgia, Iran, Iraq, Israel, Jordan, Kuwait, Lebanon, Oman, Pakistan, Qatar, Saudi Arabia, Syria, Turkey, United Arab Emirates, and Yemen.'
export enum Country {
  UnitedStates = 'united states',
  Canada = 'canada',
  India = 'india',
  Singapore = 'singapore',
  Czechia = 'czechia',
  Israel = 'israel',
  China = 'china',
  Japan = 'japan',
  UAE = 'united arab emirates',
  UK = 'united kingdom',
  Ukraine = 'ukraine',
  Hungary = 'hungary',
  Romania = 'romania',
  Portugal = 'portugal',
  Australia = 'australia',
  Egypt = 'egypt',
  // "mid-east"
  Armenia = 'armenia',
  Azerbaijan = 'azerbaijan',
  Bahrain = 'bahrain',
  Georgia = 'georgia',
  Iran = 'iran',
  Iraq = 'iraq',
  Jordan = 'jordan',
  Kuwait = 'kuwait',
  Lebanon = 'lebanon',
  Oman = 'oman',
  Pakistan = 'pakistan',
  Qatar = 'qatar',
  SaudiArabia = 'saudi arabia',
  Syria = 'syria',
  Turkey = 'turkey',
  Yemen = 'yemen'
}

export enum State {
  Alabama = 'alabama',
  Alaska = 'alaska',
  Arizona = 'arizona',
  Arkansas = 'arkansas',
  California = 'california',
  Colorado = 'colorado',
  Connecticut = 'connecticut',
  Delaware = 'delaware',
  DistrictOfColumba = 'district of columbia',
  Florida = 'florida',
  Georgia = 'georgia',
  Hawaii = 'hawaii',
  Idaho = 'idaho',
  Illinois = 'illinois',
  Indiana = 'indiana',
  Iowa = 'iowa',
  Kansas = 'kansas',
  Kentucky = 'kentucky',
  Louisiana = 'louisiana',
  Maine = 'maine',
  Maryland = 'maryland',
  Massachusetts = 'massachusetts',
  Michigan = 'michigan',
  Minnesota = 'minnesota',
  Mississippi = 'mississippi',
  Missouri = 'missouri',
  Montana = 'montana',
  Nebraska = 'nebraska',
  Nevada = 'nevada',
  NewHampshire = 'new hampshire',
  NewJersey = 'new jersey',
  NewMexico = 'new mexico',
  NewYork = 'new york',
  NorthCarolina = 'north carolina',
  NorthDakota = 'north dakota',
  Ohio = 'ohio',
  Oklahoma = 'oklahoma',
  Oregon = 'oregon',
  Pennsylvania = 'pennsylvania',
  RhodeIsland = 'rhode island',
  SouthCarolina = 'south carolina',
  SouthDakota = 'south dakota',
  Tennessee = 'tennessee',
  Texas = 'texas',
  Utah = 'utah',
  Vermont = 'vermont',
  Virginia = 'virginia',
  Washington = 'washington',
  WestVirginia = 'west virginia',
  Wisconsin = 'wisconsin',
  Wyoming = 'wyoming'
}

export const allRegions: Record<WorldRegion, GeoTreeNode> = {
  any: {
    value: { worldRegion: WorldRegion.Any, country: '', state: '' },
    children: []
  },
  'north america': {
    value: { worldRegion: WorldRegion.NorthAmerica, country: '', state: '' },
    children: [
      {
        value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: '' },
        children: [
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Alabama } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Alaska } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Arizona } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Arkansas } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.California } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Colorado } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Connecticut } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Delaware } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.DistrictOfColumba } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Florida } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Georgia } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Hawaii } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Idaho } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Illinois } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Indiana } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Iowa } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Kansas } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Kentucky } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Louisiana } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Maine } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Maryland } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Massachusetts } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Michigan } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Minnesota } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Mississippi } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Missouri } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Montana } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Nebraska } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Nevada } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.NewHampshire } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.NewJersey } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.NewMexico } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.NewYork } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.NorthCarolina } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.NorthDakota } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Ohio } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Oklahoma } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Oregon } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Pennsylvania } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.RhodeIsland } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.SouthCarolina } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.SouthDakota } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Tennessee } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Texas } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Utah } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Vermont } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Virginia } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Washington } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.WestVirginia } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Wisconsin } },
          { value: { worldRegion: WorldRegion.NorthAmerica, country: Country.UnitedStates, state: State.Wyoming } }
        ]
      },
      {
        value: { worldRegion: WorldRegion.NorthAmerica, country: Country.Canada, state: '' }
      }
    ]
  },
  'south america': {
    value: { worldRegion: WorldRegion.SouthAmerica, country: '', state: '' }
  },
  'central america': {
    value: { worldRegion: WorldRegion.CentralAmerica, country: '', state: '' }
  },
  caribbean: {
    value: { worldRegion: WorldRegion.Caribbean, country: '', state: '' }
  },
  africa: {
    value: { worldRegion: WorldRegion.Africa, country: '', state: '' },
    children: []
  },
  asia: {
    value: { worldRegion: WorldRegion.Asia, country: '', state: '' },
    children: [
      { value: { worldRegion: WorldRegion.Asia, country: Country.Armenia, state: '' } },
      { value: { worldRegion: WorldRegion.Asia, country: Country.Azerbaijan, state: '' } },
      { value: { worldRegion: WorldRegion.Asia, country: Country.Georgia, state: '' } },
      { value: { worldRegion: WorldRegion.Asia, country: Country.China, state: '' } },
      { value: { worldRegion: WorldRegion.Asia, country: Country.India, state: '' } },
      { value: { worldRegion: WorldRegion.Asia, country: Country.Japan, state: '' } },
      { value: { worldRegion: WorldRegion.Asia, country: Country.Pakistan, state: '' } },
      { value: { worldRegion: WorldRegion.Asia, country: Country.Singapore, state: '' } }
    ]
  },
  europe: {
    value: { worldRegion: WorldRegion.Europe, country: '', state: '' },
    children: [
      { value: { worldRegion: WorldRegion.Europe, country: Country.Czechia, state: '' } },
      { value: { worldRegion: WorldRegion.Europe, country: Country.Hungary, state: '' } },
      { value: { worldRegion: WorldRegion.Europe, country: Country.Portugal, state: '' } },
      { value: { worldRegion: WorldRegion.Europe, country: Country.Romania, state: '' } },
      { value: { worldRegion: WorldRegion.Europe, country: Country.Ukraine, state: '' } },
      { value: { worldRegion: WorldRegion.Europe, country: Country.UK, state: '' } }
    ]
  },
  oceania: {
    value: { worldRegion: WorldRegion.Oceania, country: '', state: '' },
    children: [
      { value: { worldRegion: WorldRegion.Oceania, country: Country.Australia, state: '' } }
    ]
  },
  'middle east': {
    value: { worldRegion: WorldRegion.MiddleEast, country: '', state: '' },
    children: [
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Bahrain, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Egypt, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Iran, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Iraq, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Israel, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Jordan, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Kuwait, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Lebanon, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Oman, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Qatar, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.SaudiArabia, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Syria, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Turkey, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.UAE, state: '' } },
      { value: { worldRegion: WorldRegion.MiddleEast, country: Country.Yemen, state: '' } }
    ]
  }
};

const makeGeographyList = (forEnt: boolean) => {
  const geographyList: Geography[] = [];
  Object.entries(allRegions).forEach(([, region]) => {
    geographyList.push(region.value);
    if (region.children) {
      region.children.forEach((country) => {
        geographyList.push(country.value);
        if (country.children) {
          country.children.forEach((state) => {
            geographyList.push(state.value);
          });
        }
      });
    }
  });
  if (!forEnt) {
    return geographyList;
  }
  return geographyList.filter((g) => g.worldRegion !== WorldRegion.Any);
};

export const EntGeographyList = makeGeographyList(true);
export const InvestorGeographyList = makeGeographyList(false);

